import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // ✅ Import Link
import './ExpertiseSection.css';

const expertiseData = [
  {
    title: "IT JOBS",
    image: "https://plus.unsplash.com/premium_photo-1733353204288-ba5c8ba3ad7d?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Opportunities across software, data, cloud, AI/ML, cybersecurity, and more.",
    details: [
      "Software Development",
      "Data Analytics",
      "Cloud Computing",
      "AI & Machine Learning",
      "DevOps & Testing",
      "Cybersecurity",
      "UI/UX Design",
      "Project Management",
    ],
  },
  {
    title: "NON-IT JOBS",
    image: "https://images.unsplash.com/photo-1688646583123-16844c80e78a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Expanding careers in HR, marketing, finance, operations, and more.",
    details: [
      "Human Resources",
      "Sales & Marketing",
      "Finance & Accounting",
      "Business Development",
      "Customer Support",
      "Operations Management",
      "Content Writing",
      "Administration",
    ],
  },
  {
    title: "FRESHERS",
    image: "https://images.unsplash.com/photo-1527689368864-3a821dbccc34?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Kickstart your career journey with entry-level jobs and internships.",
    details: [
      "Internship Programs",
      "Campus Placements",
      "Entry-Level Jobs",
      "Job Readiness Training",
      "Soft Skills Development",
      "Industry Exposure",
      "Skill Certifications",
      "Mentorship Programs",
    ],
  },
  {
    title: "FREELANCERS",
    image: "https://images.unsplash.com/photo-1630673287511-4d477913d7a0?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Flexible opportunities for freelancers and remote professionals worldwide.",
    details: [
      "Work From Anywhere",
      "Global Projects",
      "Short-Term Contracts",
      "Flexible Timings",
      "Tech & Non-Tech Gigs",
      "Digital Marketing",
      "Creative Design",
      "Consulting Roles",
    ],
  },
  {
    title: "RECRUITERS",
    image: "https://images.unsplash.com/photo-1630673507885-1754499d2d03?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Connecting organizations with the right talent pool across industries.",
    details: [
      "Talent Sourcing",
      "Candidate Screening",
      "Faster Hiring",
      "Industry-Specific Talent",
      "Verified Profiles",
      "Bulk Hiring",
      "End-to-End Hiring Solutions",
      "Recruitment Support",
    ],
  },
  {
    title: "CAREER GUIDANCE",
    image: "https://images.unsplash.com/photo-1630673429477-186308ef87d0?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Helping individuals make smarter career moves and grow professionally.",
    details: [
      "Resume Building",
      "Mock Interviews",
      "Career Counseling",
      "Skill Assessments",
      "Upskilling Recommendations",
      "Placement Support",
      "Industry Mentorship",
      "Job Market Insights",
    ],
  },
];

const ExpertiseSection = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 4;

  const prevSlide = () => {
    setStartIndex((prev) =>
      prev === 0 ? Math.max(0, expertiseData.length - visibleCount) : prev - 1
    );
  };

  const nextSlide = () => {
    setStartIndex((prev) =>
      prev + visibleCount >= expertiseData.length ? 0 : prev + 1
    );
  };

  const visibleItems = expertiseData.slice(startIndex, startIndex + visibleCount);

  return (
    <div
      className="expertise-wrapper"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1636955816868-fcb881e57954?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`,
      }}
    >
      <div className="expertise-content">
        <div className="expertise-header">
          <h2 className="expertise-heading">
            Our <span>Expertise</span>
          </h2>
          <div className="expertise-carousel-controls">
            <button onClick={prevSlide}>&#8592;</button>
            <button onClick={nextSlide}>&#8594;</button>
          </div>
        </div>

        <div className="expertise-carousel">
          {visibleItems.map((item, index) => (
            <div className="expertise-card" key={startIndex + index}>
              <img src={item.image} alt={item.title} />
              <div className="expertise-overlay">
                <h3 className="expertise-overlay-title">{item.title}</h3>
                <div className="expertise-details">
                  <p className="expertise-description">{item.description}</p>
                  <ul>
                    {item.details.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                  {/* ✅ Navigate to /joblist when clicked */}
                  <Link to="/contact">
                    <button className="expertise-learn-more">Learn more →</button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExpertiseSection;
